import { ChatMemberDto } from "@/store/modules/chat/interfaces/chatMember";

import axios from "./axios";

export interface ChatCreateRequest {
  participantId: string;
  information: {
    chiefComplaint: string;
    complaintDescription?: string;
  };
}

const access = async (): Promise<string> => {
  const { data } = await axios.get(`/chat/access`);
  return data;
};

const chatMember = async (id: string): Promise<ChatMemberDto> => {
  const { data } = await axios.get(`/chat/identity/${id}`);
  return data;
};

const create = async (request: ChatCreateRequest): Promise<ChatMemberDto> => {
  const { data } = await axios.post(`/chat`, request);
  return data;
};

export const ChatApi = { access, chatMember, create };
